import { MbGetinfoResp } from 'app/bff/models/mb/mbGetinfo';
import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { ROUTES } from 'app/core/router/paths';
import { ProcessStepCodesEnum } from 'app/features/Member/Reauth/types';
import { FormValues as ClausesFormValues } from 'app/features/Member/Reauth/Clauses/types';
import { ReauthState, ReauthActions, MEMBER_REAUTH__SAVE_MEMBER_PROFILE, MEMBER_REAUTH__SET_ACCESSIBLE_STEP, MEMBER_REAUTH__SAVE_CLAUSES_PAGE_DATA, MEMBER_REAUTH__SEND_OTP, MEMBER_REAUTH__SEND_OTP_DONE, MEMBER_REAUTH__AUTH_OTP, MEMBER_REAUTH__UPDATE_CACHE, MEMBER_REAUTH__RESET_CACHE } from './types';

/**
 * @description 緩存會員資料 (Action)
 * @param data 會員資料
 */
export const saveMemberProfileAction = (data: MbGetinfoResp): ReauthActions => ({
  type: MEMBER_REAUTH__SAVE_MEMBER_PROFILE,
  payload: { data }
});

/**
 * @description 設置可訪問步驟 (Action)
 * @param step 當前步驟
 */
export const setAccessibleStepAction = (step: ProcessStepCodesEnum): ReauthActions => ({
  type: MEMBER_REAUTH__SET_ACCESSIBLE_STEP,
  payload: { step }
});

/**
 * @description 緩存「同意相關告知事項」(Step-1) 頁面資料 (Action)
 * @param data 頁面資料
 */
export const saveClausesPageDataAction = (data: ClausesFormValues): ReauthActions => ({
  type: MEMBER_REAUTH__SAVE_CLAUSES_PAGE_DATA,
  payload: { data }
});

/**
 * @description 發送 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 * @param redirectRoute 轉導路由
 */
export const sendOTPAction = (args: AaOtpSendcodeReq, redirectRoute?: ROUTES): ReauthActions => ({
  type: MEMBER_REAUTH__SEND_OTP,
  payload: { args, redirectRoute }
});

/**
 * @description 發送 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const sendOTPDoneAction = (response: AaOtpSendcodeResp): ReauthActions => ({
  type: MEMBER_REAUTH__SEND_OTP_DONE,
  payload: { response }
});

/**
 * @description 驗證 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 */
export const authOTPAction = (args: AaOtpVerifyReq): ReauthActions => ({
  type: MEMBER_REAUTH__AUTH_OTP,
  payload: { args }
});

/**
 * @description 更新資料緩存 (Action)
 * @param cache 緩存資料
 */
export const updateCacheAction = (cache: ReauthState): ReauthActions => ({
  type: MEMBER_REAUTH__UPDATE_CACHE,
  payload: { cache }
});

/**
 * @description 重置資料緩存 (Action)
 */
export const resetCacheAction = (): ReauthActions => ({
  type: MEMBER_REAUTH__RESET_CACHE
});
